import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import FormatDateActionFields from '@/components/format-edit/FormatDateActionFields.vue'
import { useTaishokutodokeFormatData } from '@/composables/format-edit/useTaishokutodokeFormatData'

type DateField = 'createDate' | 'retirementDate'


export default /*#__PURE__*/_defineComponent({
  __name: 'TaishokutodokeDateCard',
  props: {
    currentCardId: null,
    cardId: null,
    heading: null,
    description: null,
    field: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  cardId: string
  heading: string
  description: string
  field: DateField
};



const formatData = useTaishokutodokeFormatData()

const dateValue = computed({
  get() {
    return formatData[props.field]
  },
  set(next: Date | string | null) {
    formatData[props.field] = next as Date | null
  }
})

return { __sfc: true,props, formatData, dateValue, FormatDateActionFields }
}

})